import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { UserService } from '../../../../../services/user/user.service';
import { ApirequestService } from '../../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../../services/api-urls/apiurls.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, PageEvent } from '@angular/material';
import { ConfirmdialogComponent } from '../../../../common/dialog/confirmdialog.component';
import { Router } from '@angular/router';
import { UtilityService } from '../../../../../services/utilities/utilities.services';
import { CommonService } from '../../../../../services/apiservices/common.service';

@Component({
    selector: 'hybse-admin-listusers',
    templateUrl: './listusers.component.html',
    styleUrls: ['./listusers.component.css'],
    animations: [
        trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
            params: {
                timing: 1,
                a: '-10px'
            }
        }))])
    ],
})
export class ListusersComponent implements OnInit {

    public limit: number = 50;
    public count: number;
    public offset: number = 0;
    public errorMessage: string;
    public searchEmail: string;
    public searchCount: string;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    constructor(public _us: UserService,
        public _req: ApirequestService,
        public _urls: ApiurlsService,
        public _utils: UtilityService,
        public dialog: MatDialog,
        public utils: UtilityService,
        public router: Router,
        public commonService: CommonService) { }
    fadeInDown: any;
    userList: any = [];
    pageListOriginal: any = [];
    showLoader: boolean = true;
    @Input() userType: string = 'Admin';
    listTitle: string = 'Admin List';
    getUserList(type) {
        let data = {
            userType: type,
            offset: this.offset,
            limit: this.limit,
            searchEmail: ''
        };
        if (this.searchEmail) {
            data.searchEmail = this.searchEmail;
            if (this.searchCount) {
                data.offset = this.offset;
            } else {
                this.count = undefined;
                data.offset = 0;
                this.offset = 0;
            }

        }
        this._req.fetchApiData(this._urls.adminListUrl, data).subscribe(
            (data: any) => {
                this.userList = [];
                let response = data.data;
                if (response !== '') {
                    if (response.userList.length != 0) {
                        this.userList = response.userList;
                        this.count = response.userCount;
                        if (this.searchEmail) {
                            this.count = response.searchCount;
                            this.searchCount = response.searchCount;
                        }
                    } else {
                        this.commonService.showInformationMessage(this.commonService.noRecordMsg);
                    }
                } else {
                    this.errorMessage = 'There is no record found!';
                    this.searchCount = undefined;
                }
            },
            error => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            });
    }

    confirmDelete(id) {
        const deleteDialog = this.dialog.open(ConfirmdialogComponent, {
            width: '400px',
            height: '170px',
            data: {
                message: 'Are you sure to delete this user?'
            }
        });

        deleteDialog.afterClosed().subscribe(
            data => {
                if (data) this.deleteUser(id);
            }
        );
    }

    deleteUser(id) {
        let data = { data: { idUser: id } };
        this._req.fetchApiData(this._urls.deleteUserUrl, data).subscribe(
            (data: any) => {
                let response = data;
                if (response != 0) this.deleteUserFromList(id);
            },
            error => {
            },
            () => {
            });
    }

    deleteUserFromList(id) {
        this.userList = this.utils.filterArrayObj(this.userList, 'id', id);
    }

    editUser(id) {
        if (this.userType == 'Admin') {
            this.router.navigate(['/admin/edit-user', id]);
        } else if (this.userType == 'Investor') {
            this.router.navigate(['/investor/view'], { queryParams: { idUser: id, userType: this.userType } });
        } else if (this.userType == 'Issuer') {
            // this.router.navigate(['/issuer/edit-user', id]);
           this.router.navigate(['/investor/view'], { queryParams: { idUser: id, userType: this.userType } });
        }
        else {
            this.router.navigate(['/demo-company/issuers/edit-issuer', id]);
        }
    }

    public viewInvestor(id): void {
        this.router.navigate(['/investor/view'], { queryParams: { idUser: id, userType: this.userType } });
    }


    public setUser(name: string): void {
        localStorage.setItem('userName', name);
        localStorage.setItem('userType', this.userType);
    }

    toggleActive(user, e) {
        let status = e.checked ? 'Active' : 'Inactive';
        let active = e.checked ? '0' : '1';
        const activeDialog = this.dialog.open(ConfirmdialogComponent, {
            width: '400px',
            height: '170px',
            data: {
                message: 'Are you sure to ' + status + ' the ' + user.userName + '?'
            }
        });

        activeDialog.afterClosed().subscribe(
            data => {
                (data) ? this.toggleActiveUser(user.id, e) : this.userList = this.utils.changeArrayObjProp(this.userList, 'id', user.id, 'isActive', !e.checked);
            }
        );
    }

    toggleActiveUser(id, e) {
        let data = {
            id: id,
            active: e.checked ? 1 : 0
        };
        this.userList = this.utils.changeArrayObjProp(this.userList, 'id', id, 'isActive', e.checked);
        this._req.fetchApiData(this._urls.userActiveUrl, data).subscribe(
            (data: any) => {
                let id = data.data.id;
                this.userList = this.utils.changeArrayObjProp(this.userList, 'id', id, 'isActive', e.checked);
            },
            error => {

            },
            () => {

            });
    }

    add_new_user() {
        if (this.userType == 'Admin') {
            this.router.navigate(['/admin/add-user']);
        } else if (this.userType == 'Investor') {
            this.router.navigate(['/investor/add-user']);
        } else if (this.userType == 'Issuer') {
            this.router.navigate(['/issuer/add-user']);
        }
        else {
            this.router.navigate(['/demo-company/issuers/add-issuer']);
        }
    }

    ngOnInit() {

        if (this.userType == 'Admin') this.getUserList(this.userType);
    } 

    ngOnChanges() {
        if (this.userType != 'Admin') this.getUserList(this.userType);
        if (this.userType == 'Investor') {
            this.listTitle = "Investor List";
        }
        else if (this.userType == 'Issuer') {
            this.listTitle = "Issuer List";
        }
        else if (this.userType == 'DemoIssuer') {
            this.listTitle = "DemoIssuer List";
        }
        else {
            this.listTitle = "Admin List";
        }
    }

    public searchLists(event: Event): void {
        this.searchEmail = event.target['value'];
        this.getUserList(this.userType)

    }

    public pagination(page): void {
        this.offset = page.pageIndex;
        this.limit = page.pageSize;
        this.getUserList(this.userType);
    }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/admin/listusers/listusers.component.ts